import { isNullForDisplay, isNullForTransferValue } from '@/utils/tools/utils';

export function initFloatForTwo(valueString) {
  // try {
  if (isNullForTransferValue(valueString)) {
    //     let value: string = `${valueString}`;
    //     let xsd = value.toString().split(".");
    //     if (xsd.length == 1) {
    //       value = value.toString() + ".00";
    //       return value;
    //     }
    //     if (xsd.length > 1) {
    //       if (xsd[1].length < 2) {
    //         value = value.toString() + "0";
    //       } else if (xsd[1].length > 2) {
    //         let endstring = xsd[1].substring(0, 2);
    //         value = xsd[0] + "." + endstring;
    //       }
    return valueString;
    // }
  }
  return '0.00';

  // } catch (e) {
  //   return '0.00';
  // }
}

// 拼接币种金额
export const splicingAmountAndCurrency = function(currency, amount) {
  return currency && isNullForTransferValue(amount) ? `${initFloatForTwo(amount)} ${currency}`
    : initFloatForTwo(amount);
};
// 添加选择头
export const getHeadSelectedItem = function(arr) {
  arr.unshift({
    label: 'message.searchCommon.all',
    value: '',
    isInternationalization: true,
  });
  return arr;
};

export const initSelectedData = function(data, labelName = 'description', valueName = 'value', isAddHead = true, check, labelNameSupplement) {
  const arr = [];
  if (data) {
    if (labelName && valueName) {
      data.forEach((item) => {
        const selectItem = {
          text: item[labelName] + (labelNameSupplement ? (` ${item[labelNameSupplement]}`) : ''),
          label: item[labelName] + (labelNameSupplement ? (` ${item[labelNameSupplement]}`) : ''),
          value: item[valueName],
        };
        arr.push(selectItem);
      });
    } else if (labelName && !valueName) {
      data.forEach((item) => {
        const selectItem = {
          text: item[labelName] + (labelNameSupplement ? (` ${item[labelNameSupplement]}`) : ''),
          label: item[labelName] + (labelNameSupplement ? (` ${item[labelNameSupplement]}`) : ''),
          value: item,
        };
        arr.push(selectItem);
      });
    } else {
      for (let i = 0; i < data.length; i++) {
        const selectItem = {
          text: data[i],
          label: data[i],
          value: data[i],
        };
        arr.push(selectItem);
      }
    }
    if (arr.length !== 0 && isAddHead) {
      getHeadSelectedItem(arr);
    }
  }
  return arr;
};
// 获取选择框对映的值ISelectedList作为显示数据
export const getEnantiomericValue = function(list, key) {
  let value = '';
  if (list) {
    list.forEach((item) => {
      if (`${item.value}` === `${key}`) {
        if (isNullForTransferValue(`${item.value}`)) {
          value = item.text ? item.text : item.label;
        }
      }
    });
  }
  return value;
};

// 创建一个Table数据
export const initExhibitionTable = function(data, isArray, pageSize, totalSize) {
  if (data == null) {
    return { totalElements: 0 };
  }
  let dataKey = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const dataItem in data) {
    if (data[dataItem]) {
      dataKey += 1;
    }
  }
  if (dataKey === 0) {
    return { totalElements: 0 };
  }
  const tableData = {
    content: isArray ? data : [data],
    current: 1,
    size: pageSize || 10000,
    totalElements: totalSize || 10000,
  };
  return tableData;
};

// 金额显示处理, 默认两位小数，千分位显示
export const formatMoney = (money, decimals = 2, thousandsSep = ',', decPoint = '.') => {
  const number = (money + '').replace(/[^0-9+-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
  let s = '';
  const toFixedFix = (n, prec) => {
    const k = Math.pow(10, prec);
    return '' + Math.ceil(n * k) / k;
  };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2');
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};
// 暂时没什么用
export const transformDictionaryToOptions = (data, map) => {
  const _map = map || {
    label: 'description',
    value: 'value',
  };
  const arr = [];
  if (data) {
    for (let i = 0; i < data.length; i++) {
      const selectItem = {
        text: data[i][_map.label],
        label: data[i][_map.label],
        value: data[i][_map.value],
      };
      arr.push(selectItem);
    }
  }
  return arr;
};
